import React, { useContext } from "react";
import { Icon, MainItemLink, MenuContainer, MenuItems, ItemLink, NavigationBarSecond } from "./style";
import LastItem from "./lastItem";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { sportTypes } from "../../core/config/sport-types";
import { LanguageContext } from "../../core/store";

const SubItem = ({ path, label, icon, children, menuId, menuList, handleClick, translateKey }) => {

    const { translate } = useContext(LanguageContext);

    const { sportName, type } = useParams();
    let isActive = false;

    if (sportName) {
        isActive = label === sportTypes[sportName].label;
    }

    if (type) {
        isActive = path.split("/")[0] === type;
    }

    let isMultiple = path === "/coklu-ekran";
    let isSingle = path === "/tekli-ekran";

    return (
        <>
            {children ? (
                <MainItemLink active={isActive} onClick={() => handleClick(menuId)}>
                    {isMultiple && isSingle && <Icon src={require("../../assets/images/" + icon + "-icon.svg")} />}
                    {translate(translateKey)}
                </MainItemLink>
            ) : (
                <ItemLink to={path}>
                    {isMultiple && isSingle && <Icon src={require("../../assets/images/" + icon + "-icon.svg")} />}
                    {translate(translateKey)}
                </ItemLink>
            )}

            {menuList[menuId] && children && (
                <NavigationBarSecond>
                    <MenuContainer>
                        {children.map((item) => (
                            <MenuItems key={item.path}>
                                <LastItem {...item} />
                            </MenuItems>
                        ))}
                    </MenuContainer>
                </NavigationBarSecond>
            )}
        </>
    );
};

SubItem.propTypes = {
    path: PropTypes.string,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.any,
    menuId: PropTypes.string.isRequired,
    menuList: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
    translateKey: PropTypes.string.isRequired
};

export default SubItem;
